import React from "react";
import { Skeleton } from "src/@/components/ui/skeleton";

export default function TableSkeleton() {
  return (
    <div className="space-y-4">
      {/* Table Header */}
      <div className="flex justify-between items-center px-4">
        <Skeleton className="h-6 w-1/4" />
        <Skeleton className="h-6 w-1/6" />
        <Skeleton className="h-6 w-1/6" />
        <Skeleton className="h-6 w-1/12" />
      </div>

      {/* Table Rows */}
      <div className="space-y-2">
        {Array.from({ length: 12 }).map((_, index) => (
          <div
            key={index}
            className="grid grid-cols-5 gap-5 items-center px-4 w-full"
          >
            <Skeleton className="h-10 w-full bg-slate-100" />
            <Skeleton className="h-10 w-full bg-slate-100" />
            <Skeleton className="h-10 w-full bg-slate-100" />
            <Skeleton className="h-10 w-full bg-slate-100" />
            <Skeleton className="h-10 w-1/4 bg-slate-100" />
            
          </div>
        ))}
      </div>
    </div>
  );
}
